import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireAuthModule } from "@angular/fire/auth";
import {
  AngularFireFunctionsModule,
  FunctionsRegionToken,
  FUNCTIONS_ORIGIN,
} from "@angular/fire/functions";

import { environment } from "../environments/environment.prod";

import { GooglePlus } from "@ionic-native/google-plus/ngx";
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { Camera } from "@ionic-native/camera/ngx";
import { MediaCapture } from "@ionic-native/media-capture/ngx";
import { File } from "@ionic-native/file/ngx";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { Contacts } from "@ionic-native/contacts/ngx";
import { Keyboard } from "@ionic-native/keyboard/ngx";

import { SharedModule } from "./services/share.module";
import { HttpClientModule } from "@angular/common/http";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { LocalStorageService } from "./services/local-storage.service";
import { IonicStorageModule } from "@ionic/storage";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyIonicModule } from "@ngx-formly/ionic";
import { TimerModalPage } from "./timer-modal/timer-modal.page";
import { NativeAudio } from "@ionic-native/native-audio/ngx";
// import { Calendar } from '@ionic-native/calendar';
import { VideoPlayer } from '@ionic-native/video-player/ngx'; 


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: "md",
    }),
    HttpClientModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    SharedModule,
    IonicStorageModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(),
    FormlyBootstrapModule,
    FormlyIonicModule,
  ],
  providers: [
    StatusBar,
    //   InAppBrowser,
    SplashScreen,
    GooglePlus,
    Camera,
    MediaCapture,
    File,
    FirebaseX,
    Geolocation,
    Contacts,
    Keyboard,
    
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: FunctionsRegionToken, useValue: "us-central1" },
    //  { provide: FUNCTIONS_ORIGIN, useValue: "http://localhost:5000" },
    LocalStorageService,
    // Calendar
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
